import React from "react";
import { Flex, Image } from "rebass/styled-components";
import styled from "styled-components";
import { LoadingSkeleton } from "../../../../Components/Skeloton";
import { HideOnMedium } from "../../../../Components/Wrappers";
import { Footnote, Large2, Title3 } from "../../../../Components/Text";
import Thumb from "../../../../../assets/images/studio/banners/thumbnails/Thumbnail.webp";
import Crossfire from "../../../../../assets/images/studio/banners/thumbnails/crossfire.webp";
import Audio from "../../../../../assets/images/studio/banners/audio/AudioFX.webp";
import TheSamurai from "../../../../../assets/images/studio/banners/audio/TheSamurai.webp";
import Intro from "../../../../../assets/images/studio/banners/intros/Intros.webp";
import Outro from "../../../../../assets/images/studio/banners/outros/Outros.webp";
import Reboot from "../../../../../assets/images/studio/banners/intros/reboot.webp";
import Transitions from "../../../../../assets/images/studio/banners/transitions/Transitions.webp";
import NoSignal from "../../../../../assets/images/studio/banners/transitions/nosignal.webp";
import Memes from "../../../../../assets/images/studio/banners/memes/Memes.webp";
import ThugLife from "../../../../../assets/images/studio/banners/memes/thuglife.webp";
import Overlay from "../../../../../assets/images/studio/banners/overlays/Overlays.webp";
import VHS from "../../../../../assets/images/studio/banners/overlays/vhs.webp";
import Music from "../../../../../assets/images/studio/banners/music/Music.webp";
import Hunger from "../../../../../assets/images/studio/banners/music/hunger.webp";
import Clout from "../../../../../assets/images/studio/banners/clout/Clout.webp";
import Holiday from "../../../../../assets/images/studio/banners/holiday/Holiday.webp";
import SpecialFX from "../../../../../assets/images/studio/banners/specialfx/SpecialFX.webp";
import ZoomHeadshot from "../../../../../assets/images/studio/banners/specialfx/zoomheadshot.webp";
import thumbnailsSVG from "../../../../../assets/images/studio/tags/thumbnails.svg";
import audioSVG from "../../../../../assets/images/studio/tags/audio.svg";
import overlaySVG from "../../../../../assets/images/studio/tags/overlays.svg";
import musicSVG from "../../../../../assets/images/studio/tags/music.svg";
import memesSVG from "../../../../../assets/images/studio/tags/memes.svg";
import introsSVG from "../../../../../assets/images/studio/tags/intros.svg";
import outrosSVG from "../../../../../assets/images/studio/tags/outro_icon.svg";
import transitionsSVG from "../../../../../assets/images/studio/tags/transitions.svg";
import specialfxSVG from "../../../../../assets/images/studio/tags/specialFX.svg";
import hashtagSVG from "../../../../../assets/images/studio/tags/hashtag.svg";

import {
  hunger,
  noSignal,
  reboot,
  vhs,
  thugLife,
  crossfire,
  zoomHeadshot,
  samurai,
  featuredCard,
} from "./Utilities";
import { EStudioTabView, ModalType } from "../../../../@types";
import { useRecoilState } from "recoil";
import { AllstarModalState } from "../../../../State/modals";
import { useHistory } from "react-router-dom";

export const FeaturedBanner = ({
  category,
  facetLoading,
  handleCardClick,
  view,
}: any) => {
  const bannerProps = getBannerProps(category);
  const history = useHistory();
  const [allstarModalState, setAllstarModalState] =
    useRecoilState(AllstarModalState);
  if (
    facetLoading &&
    category === "default" &&
    view === EStudioTabView.Marketplace
  )
    return (
      <HideOnMedium>
        {" "}
        <Flex mt={"13px"} mb={7} width="100%">
          <LoadingSkeleton
            height={255}
            width="100%"
            style={{ borderRadius: "20px" }}
            containerClassName="flex-grow-1"
            //@Phillip there is a container span that wraps the skeleton components, you can style it by passing a className to it.
            //I made a file for className definitions in the LoadingSkeleton folder
          />
        </Flex>
      </HideOnMedium>
    );

  if (category !== "default" || view === "Collections") return <></>;
  return (
    <>
      <Flex
        mt={[0, 0, 6, 4]}
        mb={[0, 0, 6, 7]}
        minHeight={["0px", "0px", "0px", "200px"]}
      >
        <HideOnMedium>
          <BannerWrapper
            width="100%"
            onClick={() => {
              history.push("/studio?theme=[\"Featured\"]");
            }}
          >
            <Header
              alignItems="center"
              leftImage={bannerProps.leftImage}
              borderColor={bannerProps.borderColor}
              backgroundColor={bannerProps.backgroundColor}
            ></Header>
          </BannerWrapper>
        </HideOnMedium>
      </Flex>
    </>
  );
};
const getBannerProps = (type: any) => {
  switch (type) {
    case "Music":
      return {
        leftImage: Music,
        mainImage: Hunger,
        headerTitleText: (
          <>
            {" "}
            Featured <span style={{ color: "#639FFA" }}> Music</span>
          </>
        ),
        cardTitle: "Hunger",
        iconSrc: musicSVG,
        borderColor: "#639FFA",
        backgroundColor: "#251D3F",
        tagOne: {
          colors: { borderColor: "#639FFA", hoverBorderColor: "#639FFA" },
          text: "Music",
        },
        tagTwo: {
          colors: { borderColor: "#839EAC", hoverBorderColor: "#839EAC" },
          text: "Pop",
        },
        clickProps: hunger,
      };
    case "Transitions":
      return {
        leftImage: Transitions,
        mainImage: NoSignal,
        headerTitleText: (
          <>
            {" "}
            Featured <span style={{ color: "#FDAA6E" }}> Transitions</span>
          </>
        ),
        cardTitle: "No Signal",
        iconSrc: transitionsSVG,
        borderColor: "#FDAA6E",
        backgroundColor: "#CA704F",
        tagOne: {
          colors: { borderColor: "#FDAA6E", hoverBorderColor: "#FDAA6E" },
          text: "Transitions",
        },
        tagTwo: {
          colors: { borderColor: "#839EAC", hoverBorderColor: "#839EAC" },
          text: "Cinematic",
        },
        clickProps: noSignal,
      };
    case "Intros / Outros":
      return {
        leftImage: Intro,
        mainImage: Reboot,
        headerTitleText: (
          <>
            {" "}
            Featured <span style={{ color: "#86DBFF" }}> Intros / Outros</span>
          </>
        ),
        cardTitle: "Reboot",
        iconSrc: introsSVG,
        borderColor: "#86DBFF",
        backgroundColor: "#3C7B9D",
        tagOne: {
          colors: { borderColor: "#86DBFF", hoverBorderColor: "#86DBFF" },
          text: "Intros / Outros",
        },
        tagTwo: {
          colors: { borderColor: "#839EAC", hoverBorderColor: "#839EAC" },
          text: "Cinematic",
        },
        clickProps: reboot,
      };
    case "Overlays":
      return {
        leftImage: Overlay,
        mainImage: VHS,
        headerTitleText: (
          <>
            {" "}
            Featured <span style={{ color: "#5ADAAC" }}>Overlays</span>
          </>
        ),
        cardTitle: "VHS",
        iconSrc: overlaySVG,
        borderColor: "#5adaac",
        backgroundColor: "#497E6C",
        tagOne: {
          colors: { borderColor: "#5ADAAC", hoverBorderColor: "#5ADAAC" },
          text: "Overlays",
        },
        tagTwo: {
          colors: { borderColor: "#839EAC", hoverBorderColor: "#839EAC" },
          text: "Retro",
        },
        clickProps: vhs,
      };
    case "Memes":
      return {
        leftImage: Memes,
        mainImage: ThugLife,
        headerTitleText: (
          <>
            {" "}
            Featured <span style={{ color: "#EDE175" }}> Memes</span>
          </>
        ),
        cardTitle: "Thug Life",
        iconSrc: memesSVG,
        borderColor: "#ede175",
        backgroundColor: "#A29142",
        tagOne: {
          colors: { borderColor: "#EDE175", hoverBorderColor: "#EDE175" },
          text: "Memes",
        },
        tagTwo: {
          colors: { borderColor: "#839EAC", hoverBorderColor: "#839EAC" },
          text: "Funny",
        },
        clickProps: thugLife,
      };
    case "Thumbnails":
      return {
        leftImage: Thumb,
        mainImage: Crossfire,
        headerTitleText: (
          <>
            {" "}
            Featured <span style={{ color: "#FF95C2" }}> Thumbnail</span>
          </>
        ),
        cardTitle: "Crossfire",
        iconSrc: thumbnailsSVG,
        borderColor: "#d67aa1",
        backgroundColor: "#7C4774",
        tagOne: {
          colors: { borderColor: "#FF95C2", hoverBorderColor: "#FF95C2" },
          text: "Thumbnails",
        },
        tagTwo: {
          colors: { borderColor: "#839EAC", hoverBorderColor: "#839EAC" },
          text: "Synthwave",
        },
        clickProps: crossfire,
      };
    case "Special FX":
      return {
        leftImage: SpecialFX,
        mainImage: ZoomHeadshot,
        headerTitleText: (
          <>
            {" "}
            Featured <span style={{ color: "#FF4392" }}> Special FX</span>
          </>
        ),
        cardTitle: "Zoom Headshot",
        iconSrc: specialfxSVG,
        borderColor: "#ff4392",
        backgroundColor: "#3E1C33",
        tagOne: {
          colors: { borderColor: "#FF4392", hoverBorderColor: "#FF4392" },
          text: "Special FX",
        },
        tagTwo: {
          colors: { borderColor: "#839EAC", hoverBorderColor: "#839EAC" },
          text: "Enhancement",
        },
        clickProps: zoomHeadshot,
      };
    case "Audio FX":
      return {
        leftImage: Audio,
        mainImage: TheSamurai,

        headerTitleText: (
          <>
            {" "}
            Featured <span style={{ color: "#9FF4C1" }}>Audio FX</span>
          </>
        ),
        cardTitle: "The Samurai",
        iconSrc: audioSVG,
        borderColor: "#9ff4c1",
        backgroundColor: "#498263",
        tagOne: {
          colors: { borderColor: "#9FF4C1", hoverBorderColor: "#9FF4C1" },
          text: "Audio",
        },
        tagTwo: {
          colors: { borderColor: "#839EAC", hoverBorderColor: "#839EAC" },
          text: "Knife",
        },
        clickProps: samurai,
      };
    case "Outros":
      return {
        leftImage: Outro,
        mainImage: Reboot,
        headerTitleText: (
          <>
            {" "}
            Featured <span style={{ color: "#AA95FE" }}>Outros</span>
          </>
        ),
        cardTitle: "Reboot",
        iconSrc: outrosSVG,
        borderColor: "#AA95FE",
        backgroundColor: "#6C5DA8",
        tagOne: {
          colors: { borderColor: "#AA95FE", hoverBorderColor: "#AA95FE" },
          text: "Outros",
        },
        tagTwo: {
          colors: { borderColor: "#839EAC", hoverBorderColor: "#839EAC" },
          text: "Cinematic",
        },
        clickProps: reboot,
      };
    default:
      return {
        leftImage: Holiday,
        mainImage: `${process.env.REACT_APP_S3_CLIP_BUCKET}/static/${featuredCard.ui.image}`,
        headerTitleText: (
          <>
            {" "}
            Featured <span style={{ color: "#639FFA" }}> Music</span>
          </>
        ),
        cardTitle: featuredCard.ui.title,
        fontSize: "22px",
        iconSrc: musicSVG,
        borderColor: "#639FFA",
        backgroundColor: "#251D3F",
        tagOne: {
          colors: { borderColor: "#639FFA", hoverBorderColor: "#639FFA" },
          text: featuredCard.facet.type[0],
        },
        tagTwo: {
          colors: { borderColor: "#839EAC", hoverBorderColor: "#839EAC" },
          text: featuredCard.facet.theme[0],
        },
        clickProps: featuredCard,
      };
  }
};

const Header = styled(Flex)<any>`
  background-image: url(https://media.allstar.gg/static/promotions/signatures/sig_StudioBanner.webp);
  background-position: center;
  background-repeat: no-repeat;
  background-size: auto 250px;
  background-color: #050505;
  border-radius: 20px;
  border: 3px solid;
  border-color: ${(props: any) => {
    return props.borderColor;
  }};
  width: 100%;
  height: 255px;
  max-height: 100%;
  @media (max-width: 1300px) {
    height: 216px;
  }
`;

const BannerWrapper = styled(Flex)`
  &:hover {
    cursor: pointer;
  }
`;

const StyledImage = styled(Image)<any>`
  border-radius: 10px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: right center;
  background-size: auto;
  box-shadow: -5px 5px 10px rgba(16, 16, 23, 0.4);
  min-width: 373.43px;
  height: 210px;
  @media (max-width: 1300px) {
    min-width: 302px;
    height: 170px;
  }
`;

const StyledContent = styled(Flex)<any>`
  margin-left: 20px;
  @media (max-width: 1200px) {
    margin-left: 30px;
  }
`;

const StyledContainer = styled(Flex)<any>`
  flex-direction: row;
  @media (max-width: 550px) {
    flex-direction: column-reverse;
  }
`;

const CardTitle = styled(Large2)`
  font-weight: 600;
  margin-bottom: 20px;
  line-height: 1.2;
  font-size: 40px;
  @media (max-width: 1300px) {
    margin-bottom: 15px;
    font-size: 42px;
  }
`;

const HeaderTitle = styled(Title3)`
  font-weight: 500;
  @media (max-width: 1300px) {
    display: none;
  }
`;

const IconFootnote = styled(Footnote)`
  font-weight: 500;
`;

const IconSmall = styled(Image)<any>`
  width: 12px;
  height: 12px;
  margin-right: 8px;
`;

const IconLarge = styled(Image)<any>`
  width: 20px;
  height: 20px;
  margin-right: 8px;
`;

const Tags = styled(Flex)<any>`
  background-color: #2a2835;
  border-radius: 999px;
  border-width: 1px;
  border-style: solid;
  border-color: ${(props: any) => {
    return props.borderColor;
  }};
  padding: 4px 15px;
  &:hover {
    border-color: ${(props: any) => {
      return props.hoverBorderColor;
    }};
  }
  @media (max-width: 1300px) {
    display: none;
  }
`;
